define([
    'jquery',
    './helpers/console',
    'tablesaw/dist/stackonly/tablesaw.stackonly',
    './vendor/shorten'
], function($, console, Tablesaw) {
    'use strict';

    var tableSaw = function () {
        console.log( "this should be the tablesaw object: ", Tablesaw );
        Tablesaw.init();
    };

    var init = function() {
        tableSaw();

        $(".tabs a").on('click', function (event) {
            event.preventDefault();

            var $container = $("#tabs_content"),
                $link = $(this);

            $(".tabs .on").removeClass('on');
            $(this).addClass('on');

            $container.fadeTo("fast", 0, function () {
                $.get($link.attr('href') + '_', function (data) {
                    $container.html(data);
                    $container.fadeTo("fast", 1);
                    initPrettyPhoto();
                });
            });
        });

        $(".seria_info__bodycopy").shorten({
            showChars: 300,
            minHideChars: 10,
            ellipsesText: "...",
            moreText: "виж още ...",
            lessText: "скрий",
            onLess: function() {},
            onMore: function() {},
            errMsg: null,
            force: false
        });
    };

    return {
        init: init
    };
});